import React from 'react';
import MarkdownEditor from 'Common/Components/v2/MarkdownEditor';
import { Wrapper, Title } from './styled';

const MarkdownInput = ({ title, value, onBlur, isRequired, plainText, minHeight = 60 }) => {
  return (
    <Wrapper>
      <Title children={ title } isRequired={ isRequired } />
      <MarkdownEditor
        value={ value }
        onBlur={ onBlur }
        plainText={ plainText }
        minHeight={ minHeight }
      />
    </Wrapper>
  );
};

export default MarkdownInput;
